import styled from "styled-components";
import { pxToRem, withAlpha } from "styles/utils";

/** Общая визуальная механика всех диалогов. Конкретные модалки задают только размер и содержимое. */
export const ModalOverlayBase = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => pxToRem(theme.spacing.lg)};
  background: ${({ theme }) => withAlpha(theme.colors.black, 0.5)};
`;

export const ModalSurfaceBase = styled.div`
  max-width: calc(100vw - ${({ theme }) => pxToRem(theme.spacing.xxl)});
  max-height: calc(100vh - ${({ theme }) => pxToRem(theme.spacing.xxl)});
  overflow: auto;
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.lg};
`;

export const ModalHeaderBase = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};
  padding: ${({ theme }) => pxToRem(theme.spacing.lg)} ${({ theme }) => pxToRem(theme.spacing.xxl)};

  h2 {
    margin: 0;
    color: ${({ theme }) => theme.colors.ink};
    font-size: ${({ theme }) => pxToRem(theme.fontSize.xl)};
    font-weight: 600;
    line-height: 1.25;
  }
`;

export const ModalDividerBase = styled.div`
  width: 100%;
  height: ${pxToRem(1)};
  background: ${({ theme }) => theme.borders.divider};
`;

export const ModalCloseButtonBase = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => pxToRem(theme.controlHeight.sm)};
  height: ${({ theme }) => pxToRem(theme.controlHeight.sm)};
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
  background: transparent;
  color: ${({ theme }) => theme.colors.inkMuted};
  font: inherit;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.inkSurface};
    color: ${({ theme }) => theme.colors.ink};
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  svg {
    width: ${({ theme }) => pxToRem(theme.fontSize.xl)};
    height: ${({ theme }) => pxToRem(theme.fontSize.xl)};
  }
`;

export const ModalBodyBase = styled.div`
  padding: ${({ theme }) => pxToRem(theme.spacing.xxl)};
`;

export const ModalFooterBase = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  align-items: center;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};
  width: 100%;
  padding: 0 ${({ theme }) => pxToRem(theme.spacing.xxl)} ${({ theme }) => pxToRem(theme.spacing.xxl)};

  > button {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    max-width: none;
  }

  @media (max-width: 480px) {
    grid-auto-flow: row;
    grid-template-columns: minmax(0, 1fr);

    > button {
      width: 100%;
    }
  }
`;
